import { StateService } from '@infra/state/state.service';
import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, type Resolve } from '@angular/router';
import { CompanyService } from '@api/services/company.service';
import { SignalRService } from '@infra/services/signal-r.service';
import { AuthService } from '@infra/auth/auth.service';
import { SecurityService } from '@infra/auth/security.service';
import { Globals } from '@system/globals';
import { iif, type Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';

@Injectable()
export class AdminResolver implements Resolve<boolean> {
  private readonly authService = inject(AuthService);
  private readonly securityService = inject(SecurityService);
  private readonly signalRService = inject(SignalRService);
  private readonly companyService = inject(CompanyService);
  private readonly stateService = inject(StateService);

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return this.securityService.getNewToken(route.params.companyurl).pipe(
      map(response => {
        this.authService.setLoggedIn(response.authToken);
        return this.authService.companyId;
      }),
      mergeMap(companyId =>
        iif(() => !!companyId && companyId !== Globals.EMPTY_GUID, this.companyService.get(companyId), of(null))
      ),
      tap(company => {
        if (!company) return;

        this.stateService.setCompany(company);
        this.signalRService.startConnection(this.authService.companyId, null).then();
      }),
      map(() => true)
    );
  }
}
